import { supabase } from '@/lib/supabase'
import type { UserRole } from '../types'

export async function fetchRoles(): Promise<UserRole[]> {
  const { data, error } = await supabase
    .from('roles')
    .select('*')
    .order('priority', { ascending: false })

  if (error) throw error
  return data as UserRole[]
}
